/**
 * HMO Constants
 * Defines HMO identifiers and their associated domains
 */

export enum HMO {
  LEUMIT = 'leumit',
  MACCABI = 'maccabi',
  CLALIT = 'clalit',
  MEUCHEDET = 'meuchedet',
  CLINICAL_TRIAL='clinical',
}

//for development only
export const HMO_DOMAINS: Record<HMO, string> = {
  [HMO.LEUMIT]: 'www.dev.leumit.labontime.co.il',
  [HMO.MACCABI]: 'www.dev.macabi.labontime.co.il',
  [HMO.CLALIT]: 'www.dev.clalit.labontime.co.il',
  [HMO.MEUCHEDET]: 'www.dev.meuchedet.labontime.co.il',
  [HMO.CLINICAL_TRIAL]: 'clinicalTrial',
};

export type HMOType = HMO | null;


